module.exports = __webpack_public_path__ + "img/137.1bcc3b4.svg";